<div class="modal-header">
    <h5 class="modal-title" id="emptyModalLabel">Tải lên logo</h5>
    <button type="button" class="btn-close" (click)="closeModal()" aria-label="Đóng">x</button>
  </div>
  <div class="modal-body">
    <form [formGroup]="uploadForm" (ngSubmit)="onSubmit()" enctype="multipart/form-data">
        <input type="file" formControlName="file" accept="image/*" (change)="onFileChange($event)" />
        <small class="form-text text-muted">Kích thước tối đa: 80x80 pixel</small>
        <div *ngIf="imageError" class="text-danger mt-1">{{ imageError }}</div>
        <br />
        <button class="btn btn-outline-primary" [disabled]="!fileToUpload" type="submit">Tải lên</button>
      </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="closeModal()">Đóng</button>
   <!--  <button type="button" class="btn btn-outline-primary">Save changes</button> -->
  </div>

